import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';
import React from 'react';
import Gravatar from '../../../common/Gravatar';
import TimestampTooltip from '../../../common/TimestampTooltip';

const useStyles = makeStyles(() =>
    createStyles({
        timestamp: {
            marginLeft: 8
        },
        commentBody: {
            marginTop: 8
        }
    })
);

interface Props {
    event: any;
    className?: string;
}

function CommentTimelineEvent(props: Props) {
    const classes = useStyles({});
    const { event, className } = props;

    return (
        <ListItem key={event.id} alignItems="flex-start" className={className}>
            <ListItemAvatar>
                <Gravatar email={event.email} />
            </ListItemAvatar>
            <ListItemText
                secondary={<Typography
                    className={classes.commentBody}
                    component="div"
                    variant="body1"
                    color="textPrimary"
                >
                    <div className="markdown-body" dangerouslySetInnerHTML={event.content} />
                </Typography>}
                primary={
                    <React.Fragment>
                        {event.user} added a comment
                        <TimestampTooltip timestamp={event.timestamp}>
                            <Typography
                                className={classes.timestamp}
                                component="span"
                                display="inline"
                                color="textSecondary"
                            >
                                - {moment(event.timestamp).fromNow()}
                            </Typography>
                        </TimestampTooltip>
                    </React.Fragment>
                }
            />
        </ListItem>
    );
};

export default CommentTimelineEvent;
